


















import {Component, Vue} from "vue-property-decorator";

@Component({
  name: "testing-step-2",
})
export default class TestingStep2 extends Vue{
  private testBarcode = '1000268544409'
}
